"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});const e=require("./_commonjsHelpers.cjs"),r=require("../node_modules/style-to-js/cjs/index.cjs");var t=r.__require();const o=e.getDefaultExportFromCjs(t);exports.default=o;
//# sourceMappingURL=index2.cjs.map
